import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-use-form-state';
//Using Show Validation for now
import { ShowValidator } from '@shoflo/polymer/validators/ShowValidator/ShowValidator';
import { Input, Form, FormGroup, FormFeedback } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
import styled from 'styled-components';

import StyledFormLabel from 'components/form/StyledFormLabel';

const ActionButtonWrapper = styled.div`
  float: right;
  margin-top: 18px;
`;

const RenameFolderForm = ({
  onSubmit,
  onCancel,
  existingDescription,
  existingName,
}) => {
  const [formState, { text, label }] = useFormState({
    title: existingName,
    description: existingDescription,
  });

  const { touched, validity, values } = formState;

  return (
    <Form
      data-testid="folderEditModal"
      onSubmit={(e) => {
        e.preventDefault();
        const { title, description } = values;
        const changes = {
          existingName,
          newName: title,
          newDescription: description,
        };
        onSubmit(changes);
      }}
    >
      <FormGroup>
        <StyledFormLabel
          id="folderTitleInputLabel"
          htmlFor="folderTitleInput"
          {...label('folderTitleInput')}
        >
          Name
        </StyledFormLabel>
        <Input
          data-testid="nameInput"
          id="folderTitleInput"
          aria-labelledby="folderTitleInputLabel"
          placeholder={existingName}
          {...text({
            name: 'title',
            validate: ShowValidator.title,
            touchOnChange: true,
          })}
          invalid={touched.title && !validity.title}
          required
        />
        {validity.title === false && (
          <FormFeedback>
            Uh oh! Folder names must be between 2 and 64 characters.
          </FormFeedback>
        )}
      </FormGroup>
      <FormGroup>
        <StyledFormLabel
          id="folderDescriptionInputLabel"
          htmlFor="folderDescriptionInput"
          {...label('description')}
        >
          Description
        </StyledFormLabel>
        <Input
          data-testid="descriptionInput"
          id="folderDescriptionInput"
          aria-labelledby="folderDescriptionInputLabel"
          placeholder={existingDescription}
          {...text({
            name: 'description',
            validate: ShowValidator.description,
            touchOnChange: true,
          })}
          invalid={
            touched.description &&
            !!values.description.length &&
            !validity.description
          }
        />
        {validity.description === false && !!values.description.length && (
          <FormFeedback>
            Uh oh! Folder descriptions must be between 2 and 64 characters.
          </FormFeedback>
        )}
      </FormGroup>
      <ActionButtonWrapper className="modal-footer">
        <Button
          data-testid="createButton"
          color="primary"
          disabled={
            !(
              (touched.title && validity.title) ||
              (touched.description &&
                (!values.description.length || validity.description))
            )
          }
        >
          Save
        </Button>{' '}
        <Button
          data-testid="cancelButton"
          color="secondary"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </Button>
      </ActionButtonWrapper>
    </Form>
  );
};

RenameFolderForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default RenameFolderForm;
